import styled from 'styled-components';

import { Row, Col } from 'approot/shared/grid/grid';
import {
  ContentDivider,
  ContentPageSection,
} from 'approot/shared/content-page/content-page.style';
import { mediaUp, rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing40,
} from 'approot/shared/styles/spacing.style';

export const LessonCol = styled(Col)`
  max-width: ${rem(520)};
  padding-top: ${rem(spacing16)};

  ${ContentPageSection}:first-child ${ContentDivider} {
    display: none;
  }

  ${mediaUp.md`
    flex-basis: 50%;
  `}

  ${mediaUp.lg`
    padding-top: 0;
  `}
`;

export const LessonColFixed = styled.div`
  padding-left: ${rem(spacing12)};
  padding-right: ${rem(spacing12)};
  width: 100%;

  ${mediaUp.md`
    padding-right: ${rem(spacing40)};
    width: 50%;
  `}

  @media (min-width: 1122px) {
    width: ${rem(600)};
  }
`;

export const LessonRow = styled(Row)`
  ${mediaUp.md`
    flex-wrap: nowrap;
  `}
`;
